import React from 'react'
import HorizontalBarChart from './utils/HorizontalBarChart'
import { useTheme } from '@mui/system'
import { WarrantEntity, WarrantSubscriptionPeriod } from 'types/WarrantEntity'
import { getGuarantorRate, getSubscriptionRate } from '../../pages/warrants/WarrantOutcome'
import { BarSeriesType } from '@mui/x-charts/models'

export function WarrantOutcomeChart({ isLeftAlign, warrant }: { isLeftAlign?: boolean; warrant: WarrantEntity }) {
    const theme = useTheme()

    let series: Array<Omit<BarSeriesType, 'data' | 'type'> & { data: [number]; label: string }>

    const subscriptionRate = warrant.subscriptionPeriods.reduce((acc: number | null, sp: WarrantSubscriptionPeriod) => {
        if (acc === null) {
            return getSubscriptionRate(warrant, sp)
        } else if (getSubscriptionRate(warrant, sp) === null) {
            return acc
        } else {
            return acc + (getSubscriptionRate(warrant, sp) ?? 0)
        }
    }, null)

    const guarantorRate = warrant.subscriptionPeriods.reduce((acc: number | null, sp: WarrantSubscriptionPeriod) => {
        if (acc === null) {
            return getGuarantorRate(warrant, sp)
        } else if (getGuarantorRate(warrant, sp) === null) {
            return acc
        } else {
            return acc + (getGuarantorRate(warrant, sp) ?? 0)
        }
    }, null)

    const outcomeRate = (subscriptionRate ?? 0) + (guarantorRate ?? 0)

    if (guarantorRate !== null && guarantorRate > 0) {
        series = [
            {
                label: 'Tecknat',
                data: [subscriptionRate ?? 0],
                color: theme.palette.success.main,
            },
            {
                label: 'Garanter',
                data: [guarantorRate],
                color: theme.palette.warning.main,
            },
            {
                label: 'Ej tecknat',
                data: [100 - outcomeRate],
                color: theme.palette.grey[200],
            },
        ]
    } else {
        series = [
            {
                label: 'Tecknat',
                data: [subscriptionRate ?? 0],
                color: theme.palette.success.main,
            },
            {
                label: 'Ej tecknat',
                data: [100 - outcomeRate],
                color: theme.palette.grey[200],
            },
        ]
    }

    if (subscriptionRate === null && guarantorRate === null) {
        return <span>Inte kommunicerat ännu</span>
    }

    return (
        <HorizontalBarChart
            isLeftAlign={isLeftAlign}
            series={series}
            size='small'
            labelValue={outcomeRate}
            valueDecimals={2}
        />
    )
}
